import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentLink: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M9.25 7a.75.75 0 01.11 1.492l-.11.008H7a3.5 3.5 0 00-.206 6.994L7 15.5h2.25a.75.75 0 01.11 1.492L9.25 17H7a5 5 0 01-.25-9.994L7 7h2.25zM17 7a5 5 0 01.25 9.994L17 17h-2.25a.75.75 0 01-.11-1.492l.11-.008H17a3.5 3.5 0 00.206-6.994L17 8.5h-2.25a.75.75 0 01-.11-1.492L14.75 7H17zM7 11.25h10a.75.75 0 01.102 1.493L17 12.75H7a.75.75 0 01-.102-1.493L7 11.25h10H7z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentLink
